module.exports = __webpack_public_path__ + "img/sohu.88e6837e.png";